import React, { useContext } from 'react'
import './Header.css'
import { Avatar, Col, Row, Popover, notification } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import axios from 'axios';

import { BaseUrl } from '../Constants/Constants';
import Context from '../../Context/context';

const Header = () => {
  const { dispatch } = useContext(Context);
  const navigate = useNavigate();
  
  const handleSettings = () => {
    navigate(`/settings`)
  }

  const handleLogout = () => {
    axios.get(`${BaseUrl}auth/logout`, { withCredentials: true })
      .then((res) => {
        localStorage.removeItem("Profile");
        localStorage.removeItem("companyId");
        dispatch({ type: "SET_IS_LOGGED_IN", payload: false });
        dispatch({ type: "SET_EMPLOYEE", payload: {} });
        notification.success({
          message: 'Logged out successfully',
        });
        navigate('/login');
      })
      .catch((err) => {
        localStorage.removeItem("Profile");
        localStorage.removeItem("companyId");
        dispatch({ type: "SET_IS_LOGGED_IN", payload: false });
        dispatch({ type: "SET_EMPLOYEE", payload: {} });
        notification.error({
          message: 'Logout failed. Redirecting...',
        });
        navigate('/login')
      })
  }

  const ProfileContent = (
    <div>
      <p className='Contents' onClick={handleSettings}>
        Settings
      </p>
      <p className='Contents' onClick={handleLogout}>
        Logout
      </p>
    </div>
  )

  const ProfileTitle = (
    <div className='profileTitleContainer'>
      <Row align="middle" gutter={12}>
        <Col>
          <Avatar className='profileTitleAvatar' size={40} icon={<UserOutlined />} />
        </Col>
        <Col flex="auto">
          <p className='Username'>Admin</p>
          <p className='Email'>admin@gmail.com</p>
        </Col>
      </Row>
    </div>
  )

  return (
    <div className='headerDiv'>
      <Row justify="space-between" align="middle" style={{ width: '95%' }}>
        <span>
          <img width={180} height={45} className='headerLogoImg' src='/Logo/Training Nexus 2.jpg' alt='' />
        </span>
        <span>
          <Popover 
            content={ProfileContent} 
            title={ProfileTitle} 
            trigger="click"
            placement="bottomRight"
          >
            <Avatar className='headingAvatar' size={35} icon={<UserOutlined />} />
          </Popover>
        </span>
      </Row>
    </div>
  )
}

export default Header